<template>
  <div>
    <div class="other-banner">
      <div class="w-default center">
        <ul class="crumb">
          <li>首页</li>
          <li>公司动态</li>
        </ul>
        <h1>公司动态</h1>
      </div>
    </div>
    <news type="1" style="margin-top:120px"></news>
  </div>
</template>

<script>
import news from "../compents/News";

export default {
  components: {
    news
  },
  data() {
    return {
    };
  }
};
</script>

<style lang="scss" scoped>
.other-banner{
  background: url("@/../../assets/img/banner/banner1.jpg");
}

</style>
